import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699cb5e1f782d500143c160f/templatemarketplace/src/app/wishlist/components/WishlistClient.tsx");
